import React from "react";
import Editbook from "../components/Editbook/Editbook";

export default function Editpage() {
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <Editbook />
      </div>
    </main>
  );
}
